import React from 'react';
import { Department, StyledCloudImage } from './ShopRegistrySection.styles';

interface Props {
  image: string;
}

export const ShopRegistryDepartment: React.FC<Props> = ({ image }) => {
  return (
    <Department>
      <StyledCloudImage src={image} width="100%" resizeWidth={326} mobileResizeWidth={326} optimization="default" />
    </Department>
  );
};
